import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { ExamSubjectPopupComponent } from '../exam-subject-popup/exam-subject-popup.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { element } from 'protractor';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { log } from 'console';

interface FoodNode {
  name: string;
  code: string;
  type: string;
  icon: string
  children?: FoodNode[];
  item: string;
  level: number;
  expandable: boolean;
}
export class TodoItemFlatNode {
  name: string;
  code: string;
  type: string;
  icon: string
  item: string;
  level: number;
  expandable: boolean;
  // node:string
}
export class TodoItemNode {
  children: TodoItemNode[];
  item: string;
}
@Component({
  selector: 'app-user-to-subject',
  templateUrl: './user-to-subject.component.html',
  styleUrls: ['./user-to-subject.component.scss']
})
export class UserToSubjectComponent implements OnInit {

  treeControl = new NestedTreeControl<FoodNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<FoodNode>();
  checklistSelection = new SelectionModel<TodoItemFlatNode>(true /* multiple */);
  groupArr
  subjectArr
  partArr
  headArr
  inpartArr
  selectDropdown = [{
    id: "G",
    name: 'Group',

  }, {
    id: "S",
    name: 'Subject',

  }, {
    id: "P",
    name: 'Part',

  }, {
    id: "I",
    name: 'In-Part',

  }, {
    id: "H",
    name: 'Head',

  }];
  ExamSubjectForm: FormGroup;
  submitpayload: any;
  userList
  filteredUserList
  submitButton = true;
  editButton = false;
  Branch = false;
  treeshow = false;
  subCodeArr = [];
  subCodeUnderGroupArr = [];
  grpCodeArr = [];
  subCodeArrName = [];
  grpCodeArrName = [];
  showSubmitButton = true;
  PrintIF = false;
  ExamSubjectList: [{
    ExamSubjectCode: 1
    ExamSubjectName: "test-A",
    ExamSubjectExamName: "Test-A"
  }];
  isreadonlydel = false;
  ExamSubject: string;
  list;
  childrenData: any;
  ExamSubjectform: any;
  ExamSubjectSearchForm;
  APIService: any;
  DeleteChild = false;
  deleteButton: boolean;
  ExamSubjectCodefordelete;
  isreadonly = false;
  dialogRef: MatDialogRef<any>;
  CourseList: any;
  filteredListCourse: any;
  examList: any;
  filteredListExam: any;
  ExamList: any;
  BranchList: any;
  filteredListBranch: any;
  x: string;
  emid: any;
  filteredListMustOff: never[];
  disableExam = true;
  disableNew = true;
  selecttype = true;
  dialogRef1: MatDialogRef<any>;
  strId: any;
  filterlist: { id: string; name: string; }[];
  DrpList: any;
  filteredListOfDrp: any;
  EmId: any;
  userPermission: any;
  utp: any;
  subjectCreate = true;
  subjectUpdate = true;
  subjectDelete = true;
  noCheckboxSelected = false;
  esid_list
  selectedCheckboxes: any = [];
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,) { }
  hasChild = (_: number, node: FoodNode) => !!node.children && node.children.length > 0;
  getLevel = (node: TodoItemFlatNode) => node.level;

  isExpandable = (node: TodoItemFlatNode) => node.expandable;

  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;

  ngOnInit(): void {

    this.ExamSubjectForm = this.fb.group({
      course: new FormControl('', [Validators.required]),
      exam: new FormControl('', [Validators.required]),
      strId: new FormControl(''),
      new: new FormControl(''),
      user: new FormControl(''),
      EsId: new FormControl(''),
      SubCode: new FormControl(''),
      Part: new FormControl(''),
      Inpart: new FormControl(''),
      Head: new FormControl(''),

      groupArray: new FormArray([]),
      subjectArray: new FormArray([]),
    });

    this.fetchCourse();
    this.getallUser();
  }


  addNewRow() {
    const creds = this.ExamSubjectForm.controls.groupArray as FormArray;
    creds.push(
      this.fb.group({
        grpCheckbox: new FormControl(''),
      })
    );

  }


  fetchCourse() {
    const payload = {};
    this.spinner.show();
    payload['LoginId'] = 0;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
        this.spinner.hide();
      }
      else {
        this.spinner.hide();
      }
    },);
  }


  getList(e) {
    this.spinner.show();
    this.strId = '';
    // this.fetchList();
    this.umsService.courseData = e;
    const payload = {};
    this.disableNew = true;
    this.filterlist = [];
    this.examList = [];
    this.subCodeArr = [];
    this.subCodeArrName = [];
    this.grpCodeArr = [];
    this.grpCodeArrName = [];
    this.subCodeUnderGroupArr = [];
    this.dataSource.data = [];
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredListOfDrp = [];
    payload['EmCoCode'] = e.CoCode;
    sessionStorage.setItem('CoCode', e)
    this.ExamSubjectForm.controls['exam'].setValue('')
    this.ExamSubjectForm.controls['exam'].setErrors(null);
    this.ExamSubjectForm.controls['exam'].clearValidators();
    this.ExamSubjectForm.controls['exam'].updateValueAndValidity();
    this.selecttype = true;
    // this.treeshow = false;
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.dataSource.data = [];
        this.examList = res.data;
        this.spinner.hide();
        this.filteredListExam = this.examList.slice();
        this.disableExam = false;
      }
      else {
        this.dataSource.data = [];
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }
  get(e) {
    this.PrintIF = false;
    this.subCodeArr = [];
    this.subCodeArrName = [];
    this.grpCodeArr = [];
    this.grpCodeArrName = [];
    this.subCodeUnderGroupArr = [];
    this.dataSource.data = [];
    this.spinner.show();
    this.selecttype = false;
    this.filterlist = []
    this.filteredListBranch = [];
    this.filteredListOfDrp = [];
    this.umsService.examData = e;
    this.emid = e.EmId;
    this.strId = 0;
    if (e.EmStreams == "Y") {
      this.dataSource.data = [];
      this.filterlist = [];
      this.spinner.hide();
      this.Branch = true;
      this.disableNew = true;
      this.PrintIF = false;
      this.fetchBranch(e.EmId);
      // this.emid = e.EmId;
    }

    else {
      this.spinner.hide();
      this.Branch = false;
      this.disableNew = false;
      this.filterlist = [];
      // this.selecttype = false;
      const payload = {};
      payload['EsEmId'] = e.EmId;
      payload['EsStrId'] = 0;
      this.umsService.getExamSubMapFetch(payload).subscribe(res => {
        if (res.data == '') {
          this.PrintIF = false;
        }
        else if (res.data != '') {
          this.PrintIF = true;
        }

        // this.fetchList();
        this.spinner.hide();
        // this.treeshow = true;
        this.filterlist = this.selectDropdown.slice();
        this.dataSource.data = res.data.children;
        this.childrenData = res.data.children;
        this.childrenData.forEach(element => {
          if (element.children.length > 0) {
            this.DeleteChild = false;
          }
          else {
            this.DeleteChild = true;
          }
        });
        // this.duplicate();
      });
    }
  }

  getStr(e) {
    this.subCodeArr = [];
    this.subCodeArrName = [];
    this.grpCodeArr = [];
    this.grpCodeArrName = [];
    this.subCodeUnderGroupArr = [];
    this.dataSource.data = [];
    this.filteredListOfDrp = [];
    this.disableNew = false;
    this.strId = e.StrId;
    let payload = {};
    payload['EsEmId'] = this.emid;
    payload['EsStrId'] = e.StrId;
    this.umsService.examstrData = e;
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      if (res.data == '') {
        this.PrintIF = false;
      }
      else if (res.data != '') {
        this.PrintIF = true;
      }
      // this.fetchList();
      this.filterlist = this.selectDropdown.slice();
      this.dataSource.data = res.data.children;
      this.childrenData = res.data.children;
      this.childrenData.forEach(element => {
        if (element.children.length > 0) {
          this.DeleteChild = false
        }
        else {
          this.DeleteChild = true
        }
      });
    });
  }

  fetchBranch(id) {
    const payload = {};
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }

  openSubjectExamPopUP(e, n, type) {
    let data = {};
    data['id'] = e;
    data['value'] = n;
    data['subCodee'] = this.subCodeArr;
    data['grpCode'] = this.grpCodeArr;
    data['subCodeUnderGroup'] = this.subCodeUnderGroupArr;
    data['subCodeName'] = this.subCodeArrName;
    data['grpCodeName'] = this.grpCodeArrName;
    data['type'] = type;
    data['branchId'] = this.strId;
    data['SubData'] = this.childrenData;
    if (type == 'delete') {
      const data = {};
      data['message'] = 'Are You Sure You Want To Delete This Record ?';
      data['title'] = 'Alert';
      data['icon'] = 'fa fa-question';
      this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        if (result === 'yes') {
          this.deletedata(n.EsId);
        } else {
          // this.ngOnInit();
        }
      });
    }
    else {
      this.dialogRef1 = this.dialog.open(ExamSubjectPopupComponent, {
        disableClose: true,
        width: "140vh",
        height: "auto",
        data,
      });
      this.dialogRef1.afterClosed().subscribe((result) => {
        this.get(this.umsService.examData)
        this.getStr(this.strId);
      });
    }

  }


  deletedata(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        EsId: id,
      },
    };
    this.httpClient.delete(this.APIService + '/masters/exam-subject', options)
      .subscribe((s) => {
        this.spinner.hide();
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.get(this.umsService.examData)
          this.getStr(this.strId);
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.get(this.umsService.examData)
          this.getStr(this.strId);
        });
      });
  }



  getallUser() {
    this.spinner.show();
    let payload = {}
    this.umsService.getUserList(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.userList = res.data;
        this.filteredUserList = this.userList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }





  /** Whether all the descendants of the node are selected */
  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return descendants.every(child => this.checklistSelection.isSelected(child));
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }


  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);
  }

  onCheckboxChanged(event: any, checkbox: any): void {
    this.noCheckboxSelected = false;
    // const index = this.selectedCheckboxes.indexOf(checkbox);
    const index = this.selectedCheckboxes.findIndex(item => item.EsId === checkbox.EsId);

    const isChecked = event.checked;
    const checkboxCopy = { ...checkbox }; // Create a shallow copy

    if (isChecked && index === -1) {
      // this.selectedCheckboxes.push(checkbox);
      this.selectedCheckboxes.push(checkboxCopy);
    } else if (!isChecked && index !== -1) {
      this.selectedCheckboxes.splice(index, 1);
    }

  }



  save() {
    // this.spinner.show();


    this.submitpayload = this.ExamSubjectForm.value;
    let abcd = this.selectedCheckboxes;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      abcd.forEach((element, index, array) => {
        if (element.EsType === 'G') {
          this.groupArr = []
          this.groupArr.push(element.EsId)
          let arr1 = [];
          arr1.push(
            this.fb.group({
              OpId: new FormControl(this.ExamSubjectForm.value.user),
              EmId: new FormControl(this.ExamSubjectForm.value.exam),
              CoCode: new FormControl(this.ExamSubjectForm.value.course),
              EsId: new FormControl(element.EsId),
              SubCode: new FormControl(''),
              Part: new FormControl(''),
              Inpart: new FormControl(''),
              Head: new FormControl(''),
            }),
          )
          this.umsService.addUserSubjectMapping(arr1[0].value).subscribe(res => {
            //   this.spinner.hide();
            //   // if (res.status == false) {
            //   //   iserror = true;
            //   //   this.errMsg = res.message
            //   // }
            //   // if (index === array.length - 1) resolve();
            //   // else {
            //   //   iserror = false
            //   //   this.errMsg = res.message
            //   // }
            // }, (ERROR: HttpErrorResponse) => {
            //   // iserror = true;
            //   // this.errMsg = ERROR.error.message
            //   // if (index === array.length - 1) resolve();
          });
          //subj save
          element.children.forEach((subject, index, array) => {
            this.subjectArr = [];
            this.subjectArr.push(subject.EsId)
            let arr1 = [];
            arr1.push(
              this.fb.group({
                OpId: new FormControl(this.ExamSubjectForm.value.user),
                EmId: new FormControl(this.ExamSubjectForm.value.exam),
                CoCode: new FormControl(this.ExamSubjectForm.value.course),
                EsId: new FormControl(element.EsId),
                SubCode: new FormControl(subject.EsId),
                Part: new FormControl(''),
                Inpart: new FormControl(''),
                Head: new FormControl(''),
              }),
            )
            this.umsService.addUserSubjectMapping(arr1[0].value).subscribe(res => {
              //   this.spinner.hide();
              //   // if (res.status == false) {
              //   //   iserror = true;
              //   //   this.errMsg = res.message
              //   // }
              //   // if (index === array.length - 1) resolve();
              //   // else {
              //   //   iserror = false
              //   //   this.errMsg = res.message
              //   // }
              // }, (ERROR: HttpErrorResponse) => {
              //   // iserror = true;
              //   // this.errMsg = ERROR.error.message
              //   // if (index === array.length - 1) resolve();
            });
            subject.children.forEach((part, index, array) => {
              this.partArr = [];
              this.partArr.push(part.EsId)
              let arr1 = [];
              arr1.push(
                this.fb.group({
                  OpId: new FormControl(this.ExamSubjectForm.value.user),
                  EmId: new FormControl(this.ExamSubjectForm.value.exam),
                  CoCode: new FormControl(this.ExamSubjectForm.value.course),
                  EsId: new FormControl(element.EsId),
                  SubCode: new FormControl(subject.EsId),
                  Part: new FormControl(part.EsId),
                  Inpart: new FormControl(''),
                  Head: new FormControl(''),
                }),
              )
              this.umsService.addUserSubjectMapping(arr1[0].value).subscribe(res => {
                //   this.spinner.hide();
                //   // if (res.status == false) {
                //   //   iserror = true;
                //   //   this.errMsg = res.message
                //   // }
                //   // if (index === array.length - 1) resolve();
                //   // else {
                //   //   iserror = false
                //   //   this.errMsg = res.message
                //   // }
                // }, (ERROR: HttpErrorResponse) => {
                //   // iserror = true;
                //   // this.errMsg = ERROR.error.message
                //   // if (index === array.length - 1) resolve();
              });
              //part
              part.children.forEach((inpart, index, array) => {
                if (inpart.EsType === 'H') {
                  this.headArr = [];
                  this.headArr.push(inpart.EsId)
                  var headvalue = parseInt(this.headArr[0], 10);
                }
                else {
                  this.inpartArr = [];
                  this.inpartArr.push(inpart.EsId)
                  var inpartvalue = parseInt(this.inpartArr[0], 10);
                }
                let arr1 = [];
                arr1.push(
                  this.fb.group({
                    OpId: new FormControl(this.ExamSubjectForm.value.user),
                    EmId: new FormControl(this.ExamSubjectForm.value.exam),
                    CoCode: new FormControl(this.ExamSubjectForm.value.course),
                    EsId: new FormControl(element.EsId),
                    SubCode: new FormControl(subject.EsId),
                    Part: new FormControl(part.EsId),
                    Inpart: new FormControl(inpartvalue),
                    Head: new FormControl(headvalue),
                  }),
                )
                this.umsService.addUserSubjectMapping(arr1[0].value).subscribe(res => {
                  //   this.spinner.hide();
                  //   // if (res.status == false) {
                  //   //   iserror = true;
                  //   //   this.errMsg = res.message
                  //   // }
                  //   // if (index === array.length - 1) resolve();
                  //   // else {
                  //   //   iserror = false
                  //   //   this.errMsg = res.message
                  //   // }
                  // }, (ERROR: HttpErrorResponse) => {
                  //   // iserror = true;
                  //   // this.errMsg = ERROR.error.message
                  //   // if (index === array.length - 1) resolve();
                });
              })

            })


          })

        }
        else {
          this.subjectArr = [];
          this.subjectArr.push(element.EsId);

          let arr1 = [];
          arr1.push(
            this.fb.group({
              OpId: new FormControl(this.ExamSubjectForm.value.user),
              EmId: new FormControl(this.ExamSubjectForm.value.exam),
              CoCode: new FormControl(this.ExamSubjectForm.value.course),
              EsId: new FormControl(''),
              SubCode: new FormControl(element.EsId),
              Part: new FormControl(''),
              Inpart: new FormControl(''),
              Head: new FormControl(''),
            }),
          )
          this.umsService.addUserSubjectMapping(arr1[0].value).subscribe(res => {
            //   this.spinner.hide();
            //   // if (res.status == false) {
            //   //   iserror = true;
            //   //   this.errMsg = res.message
            //   // }
            //   // if (index === array.length - 1) resolve();
            //   // else {
            //   //   iserror = false
            //   //   this.errMsg = res.message
            //   // }
            // }, (ERROR: HttpErrorResponse) => {
            //   // iserror = true;
            //   // this.errMsg = ERROR.error.message
            //   // if (index === array.length - 1) resolve();
          });
          element.children.forEach((part, index, array) => {
            this.partArr = [];
            this.partArr.push(part.EsId)
            //here save part
            let arr1 = [];
            arr1.push(
              this.fb.group({
                OpId: new FormControl(this.ExamSubjectForm.value.user),
                EmId: new FormControl(this.ExamSubjectForm.value.exam),
                CoCode: new FormControl(this.ExamSubjectForm.value.course),
                EsId: new FormControl(''),
                SubCode: new FormControl(element.EsId),
                Part: new FormControl(part.EsId),
                Inpart: new FormControl(''),
                Head: new FormControl(''),
              }),
            )
            this.umsService.addUserSubjectMapping(arr1[0].value).subscribe(res => {
              //   this.spinner.hide();
              //   // if (res.status == false) {
              //   //   iserror = true;
              //   //   this.errMsg = res.message
              //   // }
              //   // if (index === array.length - 1) resolve();
              //   // else {
              //   //   iserror = false
              //   //   this.errMsg = res.message
              //   // }
              // }, (ERROR: HttpErrorResponse) => {
              //   // iserror = true;
              //   // this.errMsg = ERROR.error.message
              //   // if (index === array.length - 1) resolve();
            });

            //save head and inpart
            part.children.forEach((inpart, index, array) => {
              if (inpart.EsType === 'H') {
                this.headArr = [];
                this.headArr.push(inpart.EsId)
                var headvalue = parseInt(this.headArr[0], 10);
              }
              else {
                this.inpartArr = [];
                this.inpartArr.push(inpart.EsId)
                var inpartvalue = parseInt(this.inpartArr[0], 10);
              }
              let arr1 = [];
              arr1.push(
                this.fb.group({
                  OpId: new FormControl(this.ExamSubjectForm.value.user),
                  EmId: new FormControl(this.ExamSubjectForm.value.exam),
                  CoCode: new FormControl(this.ExamSubjectForm.value.course),
                  EsId: new FormControl(''),
                  SubCode: new FormControl(element.EsId),
                  Part: new FormControl(part.EsId),
                  Inpart: new FormControl(inpartvalue),
                  Head: new FormControl(headvalue),
                }),
              )
              this.umsService.addUserSubjectMapping(arr1[0].value).subscribe(res => {
                //   this.spinner.hide();
                //   // if (res.status == false) {
                //   //   iserror = true;
                //   //   this.errMsg = res.message
                //   // }
                //   // if (index === array.length - 1) resolve();
                //   // else {
                //   //   iserror = false
                //   //   this.errMsg = res.message
                //   // }
                // }, (ERROR: HttpErrorResponse) => {
                //   // iserror = true;
                //   // this.errMsg = ERROR.error.message
                //   // if (index === array.length - 1) resolve();
              });
            })
          })

        }
      })
      // this.selectedCheckboxes.forEach((group, index, array) => {
      //   this.groupArr = []
      //   this.groupArr.push(group.EsId)
      //   group.children.forEach((subject, index, array) => {
      //     this.subjectArr = [];
      //     this.subjectArr.push(subject.EsId)
      //     subject.children.forEach((part, index, array) => {
      //       this.partArr = [];
      //       this.partArr.push(part.EsId)

      //       part.children.forEach((inpart, index, array) => {
      //      if(inpart.EsType === 'H'){
      //       this.headArr = [];
      //       this.headArr.push(inpart.EsId)
      //       var headvalue = parseInt(this.headArr[0], 10);
      //      }
      //      else{
      //       this.inpartArr = [];
      //       this.inpartArr.push(inpart.EsId)
      //       var inpartvalue = parseInt(this.inpartArr[0], 10);
      //      }
      //      let arr1 = [];
      //      arr1.push(
      //        this.fb.group({
      //          OpId: new FormControl(this.ExamSubjectForm.value.user),
      //          EmId: new FormControl(this.ExamSubjectForm.value.exam),
      //          CoCode: new FormControl(this.ExamSubjectForm.value.course),
      //          EsId: new FormControl(group.EsId),
      //          SubCode: new FormControl(subject.EsId),
      //          Part: new FormControl(part.EsId),
      //          Inpart: new FormControl(inpartvalue),
      //          Head: new FormControl(headvalue),
      //        }),
      //      )
      //      this.umsService.addUserSubjectMapping(arr1[0].value).subscribe(res => {
      //        //   this.spinner.hide();
      //        //   // if (res.status == false) {
      //        //   //   iserror = true;
      //        //   //   this.errMsg = res.message
      //        //   // }
      //        //   // if (index === array.length - 1) resolve();
      //        //   // else {
      //        //   //   iserror = false
      //        //   //   this.errMsg = res.message
      //        //   // }
      //        // }, (ERROR: HttpErrorResponse) => {
      //        //   // iserror = true;
      //        //   // this.errMsg = ERROR.error.message
      //        //   // if (index === array.length - 1) resolve();
      //      });
      //       })

      //     })


      //   })




      // });

    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else {
        let data = {}
        // data['message'] = this.errMsg
        // data['title'] = 'Alert'
        // data['icon'] = 'fas fa-close'
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    });
  }



  //   save11(){
  //  let payload =   this.selectedCheckboxes;
  // payload.forEach(element =>{


  //   let esid_values = this.getesid(element);
  // })

  //   }


  //   getesid(data) {
  //      this.esid_list = [];

  //     // Extract EsId from the current level
  //     thisesid_list.push(data.EsId);
  // return
  //     // Recursively extract EsId from children using foreach
  //     if (data.children) {
  //         data.children.forEach(child => {
  //             esid_list = esid_list.concat(this.getesid(child));
  //         });
  //     }

  //     // return esid_list;
  // }


  getsubmappingData() {

    // @MarkEntryMapId

    this.spinner.show();
    let payload = {}
    payload['MarkEntryMapId'] = ''
    this.umsService.getSubUsermappingList(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
}
